import React, { useCallback, useMemo } from 'react';

import { useGetAcademySchedulesQuery } from 'services/academyScheduleService';
import Select from 'components/Select';
import stringifyAcademySchedule from 'utils/stringifyAcademySchedule';

function AcademyScheduleSelect(props) {
  const { isLoading, error, data, refetch } = useGetAcademySchedulesQuery();

  const options = useMemo(() => {
    if (data?.data) {
      return data.data.map((schedule) => ({
        label: stringifyAcademySchedule(schedule),
        value: schedule.id,
        dayTimes: schedule.day_times,
      }));
    } else {
      return [];
    }
  }, [data]);

  const noOptionsMessage = useCallback(() => {
    if (isLoading) {
      return 'Loading schedules...';
    } else if (error) {
      return 'Failed to load schedules.';
    } else {
      return 'No matching schedule found.';
    }
  }, [isLoading, error]);

  return (
    <>
      <Select
        {...props}
        noOptionsMessage={noOptionsMessage}
        options={options}
        placeholder="Select a schedule"
      />
      {error && !isLoading && (
        <div className="m-t-xxs h6 hint">
          Failed to load schedules.
          <span
            className="danger m-l-xxs cursor"
            onClick={refetch}
          >
            Try again
          </span>
        </div>
      )}
    </>
  );
}

export default AcademyScheduleSelect;
